import ViewCounter from './modules/ViewCounter';

export default ViewCounter;
